export enum PaymentExportFormat {
  Generic,
  BankLineV1,
  HSBCHex4w,
  BankLineV2,
  BankLineV2Bulk,
  LloydsTelePay,
  SEPA1_0,
  BarclaysSIFPegasusOpera,
  SEPA1_1,
  Santander,
  BankOfIreland,
  LloydsFasterPayments,
  LloydsBACS,
  CouttsCoFasterPayments,
  MetroBank,
  Handelsbanken,
  Virgin,
}
